// class MenuMobile {
//   // 1. describe and create/initiate object
//   constructor() {
//     this.toggleBurgerMobile = document.querySelector("#toggle-burger-mobile")
//     this.menuContainer = document.querySelector(".menu-primary-mobile")
//     this.menuItemHasChildren = document.querySelectorAll(
//       ".menu-item-has-children"
//     )
//     this.events()
//   }

//   // 2. events
//   events() {
//     this.toggleBurgerMobile.addEventListener("click", (e) =>
//       { 
//         console.log("hamburger clicked")
//         this.toggleBurger(e) 
//       }
//     )


//     for (let i = 0; i < this.menuItemHasChildren.length; i++) {
//       this.menuItemHasChildren[i].addEventListener("click", (e) => {
//         e.preventDefault();  
//         this.menuItemHasChildren[i].classList.toggle('submenu-open');
//       })
//     }
//     window.addEventListener("resize", () => this.closeAll())
//   }

//   // 3. methods
//   toggleBurger() {
    
//     this.toggleBurgerMobile.classList.toggle("is-active")
//     this.menuContainer.classList.toggle("show-mobile-menu")
//   }
//   closeAll() {
//     this.toggleBurgerMobile.classList.remove("is-active")
//     this.menuContainer.classList.remove("show-mobile-menu")
//   }
// }

// export default MenuMobile






class MenuMobile {
  constructor(menuSelector = '.menu-primary-mobile') {
    // find the nav; if it doesn't exist, bail out completely
    this.menuContainer = document.querySelector(menuSelector)
    if (!this.menuContainer) return

    // your burger toggle lives elsewhere, so grab it globally
    this.toggleBurgerMobile = document.getElementById('toggle-burger-mobile')
    this.events()
  }

  events() {
    // only wire up the burger if it exists
    if (this.toggleBurgerMobile) {
      this.toggleBurgerMobile.addEventListener('click', e => {
        e.preventDefault()              // stop the <a> from jumping
        this.toggleBurger()
      })
    }

    // delegate submenu‐toggles to the nav itself
    this.menuContainer.addEventListener('click', e => {
      // look for clicks on the <a> inside a .menu-item-has-children
      const anchor = e.target.closest('.menu-item-has-children > a')
      if (!anchor || !this.menuContainer.contains(anchor)) return

      e.preventDefault()               // only here, and only inside our mobile menu
      anchor.parentElement.classList.toggle('submenu-open')
    })

    // global resize still closes it
    window.addEventListener('resize', () => this.closeAll())
  }

  toggleBurger() {
    this.toggleBurgerMobile.classList.toggle('is-active')
    this.menuContainer.classList.toggle('show-mobile-menu')
  }

  closeAll() {
    this.toggleBurgerMobile.classList.remove('is-active')
    this.menuContainer.classList.remove('show-mobile-menu')
  }
}

export default MenuMobile

